import { device } from 'constants/media-query'
import styled from 'styled-components'

export const InputContainer = styled.div`
  width: 100%;
  margin-bottom: 12px;
  position: relative;

  &.error {
    input {
      border: 1px solid #ff0000;
    }
  }

  &.personal-details-edit {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    position: relative;
    .error {
      position: absolute;
      bottom: -20px;
    }
    &:has(> em) {
      position: absolute;
      top: 100%;
    }

    @media ${device.desktop} {
      text-align: start;
      font-size: 14px;
      font-weight: 500;
    }
  }
`

export const Label = styled.label`
  width: 100%;
  display: flex;
  flex-direction: row;
  font-weight: 500;
  font-size: 15px;
  line-height: 100%;
  color: #000000;
  text-align: start;
`

export const Input = styled.input<{ disabled?: boolean; type?: string }>`
  font-family: ${({ theme }) => theme.fonts.inter}, sans-serif;
  font-optical-sizing: auto;
  font-style: normal;
  font-variation-settings: 'wdth' 100;
  box-sizing: border-box;
  width: 100%;
  height: 44px;
  padding: 20px 10px;
  font-size: 17px;
  font-weight: 600;
  line-height: 9px;
  color: #000000;
  border: 1px solid #9c9c9c;
  border-radius: 5px;
  background-color: rgba(245, 245, 245, 1);

  ${({ disabled }) => disabled && 'cursor: not-allowed'};
  ${({ type }) =>
    type === 'password' &&
    'letter-spacing: 0.17em;'} // Conditional styling for password type

  &:focus {
    outline: none;
  }

  &.personal-details-edit {
    display: flex;
    padding: 16px;
    justify-content: flex-end;
    align-items: center;
    border-radius: 4px;
    border: 1px solid #adafac;
    background: transparent;
    font-size: 16px;
    font-weight: 400;
  }
`
